module.exports = __webpack_public_path__ + "img/img-7.71be5746.png";